import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import { simulateNavigation } from '../../modal/RouteBlocker';
import StyledTabs from './styled/StyledTabs';
/**
 * Similar to TabNavigation but if `startBlockingRouteNavigation` has been called, confirm
 * dialog will be shown before transitioning.
 *
 * @author Jan Prokop
 */

export var TabNavigationBlockable = function TabNavigationBlockable(_a) {
  var fullWidth = _a.fullWidth,
      props = __rest(_a, ["fullWidth"]);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tabIndex = _React$useState2[0],
      setTabIndex = _React$useState2[1];

  var onSelect = React.useCallback(function (index, lastIndex, event) {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return simulateNavigation();

            case 3:
              if (!props.onSelect) {
                _context.next = 6;
                break;
              }

              if (!(props.onSelect(index, lastIndex, event) === false)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              setTabIndex(index);
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
  }, []);
  return React.createElement(StyledTabs, {
    fullWidth: fullWidth
  }, React.createElement(Tabs, Object.assign({}, props, {
    selectedIndex: tabIndex,
    onSelect: onSelect
  }), React.createElement(TabList, null, props.content.map(function (tab) {
    return React.createElement(Tab, {
      key: tab.tabName
    }, tab.tabName);
  })), props.content.map(function (tab) {
    return React.createElement(TabPanel, {
      key: tab.tabName
    }, tab.tabContent);
  })));
};